import React from 'react';
import { groupFieldsIntoRows, filterExcludedQuestions } from './utils';
import {
  QuestionRow,
  GroupFieldContainer,
  GroupFieldHeader,
  GroupFieldTitle,
} from './DynamicQuestionForm.styled';
import { QuestionField } from './QuestionField';
import { GroupFieldProps } from '../../../types/questionForm';

// Group Component for nested fields
export const GroupField: React.FC<GroupFieldProps> = ({
  question,
  answers,
  onAnswerChange,
  hasCountryChangedRef,
  hasDestinationChangedRef,
}) => {
  if (!question.fields) return null;

  // Filter out excluded fields
  const visibleFields = filterExcludedQuestions(question.fields);
  const groupFieldRows = groupFieldsIntoRows(visibleFields);

  return (
    <GroupFieldContainer>
      {question.label && (
        <GroupFieldHeader>
          <GroupFieldTitle>{question.label}</GroupFieldTitle>
        </GroupFieldHeader>
      )}

      {groupFieldRows.map((row, rowIndex) => {
        const isSingleColumn = row.length === 1 && row[0].colSpan === 2;

        return (
          <QuestionRow
            key={rowIndex}
            className={isSingleColumn ? 'single-column' : ''}
          >
            {row.map(field => (
              <QuestionField
                key={field.id}
                question={field}
                value={answers[field.id]?.value ?? field.defaultValue}
                onChange={(value: any) => onAnswerChange(field.id, value)}
                answers={answers}
                onAnswerChange={onAnswerChange}
                hasCountryChangedRef={hasCountryChangedRef}
                hasDestinationChangedRef={hasDestinationChangedRef}
              />
            ))}
          </QuestionRow>
        );
      })}
    </GroupFieldContainer>
  );
};
